import convertToTime from './convertToTime';

const calculatePace = ({ hours = 0, minutes = 0, seconds = 0, distance, wantTime = true }) => {
    if (!Number(distance)) {
        return '0';
    }
    const totalSeconds = (Number(hours) * 60 * 60) + (Number(minutes) * 60) + Number(seconds);
    if (totalSeconds === 0) {
        return '0';
    }
    const paceInSeconds = totalSeconds / distance;
    if (wantTime) {
        return convertToTime(paceInSeconds);
    }
    return paceInSeconds;
};

export default calculatePace;



/** WEBPACK FOOTER **
 ** ./src/utils/calculatePace.js
 **/